import styled, { keyframes } from "styled-components";

import {
  ANIMATION,
  QUERIES,
  SPACING,
  SPACING_RESPONSIVE,
} from "../../../../../utils/constants";

// The global prefers-reduced-motion rule in GlobalStyles stills this sweep.
const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;

export const SkeletonBox = styled.div<{ width?: string; height?: string }>`
  width: ${(props) => props.width || "100%"};
  max-width: 100%;
  height: ${(props) => props.height || "20px"};
  background: var(--gradient-skeleton);
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s ${ANIMATION.easing.easeInOut} infinite;
  border-radius: 4px;
`;

export const HeroCardSkeleton = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.lg}px;
  border-radius: 12px;
  background: var(--hero-background);
  border: 1px solid var(--color-card-border);
  box-shadow: var(--shadow-small);
  padding: ${SPACING_RESPONSIVE.mobile.cardPadding}px;

  @media ${QUERIES.tabletLargeAndUp} {
    padding: ${SPACING_RESPONSIVE.tablet.cardPadding}px;
  }

  @media ${QUERIES.laptopAndUp} {
    padding: ${SPACING_RESPONSIVE.desktop.cardPadding}px;
  }
`;

export const HeadSkeleton = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.md}px;

  @media ${QUERIES.tabletLargeAndUp} {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }
`;

export const HeadActionsSkeleton = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${SPACING.sm}px;

  @media ${QUERIES.tabletLargeAndUp} {
    grid-template-columns: 100px 150px;
  }
`;

export const StackSkeleton = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.sm}px;
`;

export const HeroMainSkeleton = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${SPACING.lg}px;

  @media ${QUERIES.laptopAndUp} {
    grid-template-columns: 1.15fr 1fr;
    gap: ${SPACING.xxl}px;
  }
`;

export const ValuePairSkeleton = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${SPACING.md}px;

  @media ${QUERIES.tabletLargeAndUp} {
    grid-template-columns: 1.2fr 1fr;
    gap: ${SPACING.lg}px;
  }
`;

export const StripSkeleton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${SPACING.md}px;
  border-top: 1px solid var(--color-border);
  padding-top: ${SPACING.md}px;
`;

export const SectionCardSkeleton = styled.section`
  background: var(--color-card-background);
  border: 1px solid var(--color-card-border);
  border-radius: 12px;
  box-shadow: var(--shadow-small);
  display: flex;
  flex-direction: column;
  gap: ${SPACING.md}px;
  padding: ${SPACING_RESPONSIVE.mobile.chartPadding}px;
  margin: ${SPACING_RESPONSIVE.mobile.sectionGap}px;
  margin-bottom: 0px;

  @media ${QUERIES.tabletAndUp} {
    padding: ${SPACING_RESPONSIVE.tablet.chartPadding}px;
    margin: ${SPACING_RESPONSIVE.tablet.sectionGap}px;
    margin-bottom: 0px;
  }

  @media ${QUERIES.laptopAndUp} {
    padding: ${SPACING_RESPONSIVE.desktop.chartPadding}px;
    margin: ${SPACING_RESPONSIVE.desktop.sectionGap}px;
    margin-bottom: 0px;
  }
`;

export const SectionHeaderSkeleton = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.md}px;

  @media ${QUERIES.tabletAndUp} {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
  }
`;

export const SectionTitleBlockSkeleton = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.xs}px;
`;

export const ChartAreaSkeleton = styled(SkeletonBox)`
  height: 300px;

  @media ${QUERIES.tabletAndUp} {
    height: 380px;
  }
`;
